import { supabase } from "@/integrations/supabase/client";

export type NotifyType =
  | "parent_invite_sent"
  | "parent_invite_accepted"
  | "parent_invite_expired"
  | "parent_consent_granted"
  | "parent_consent_withdrawn"
  | "parent_guide_ready"
  | "parent_guide_reminder"
  | "parent_report_ready"
  | "teacher_assignment"
  | "student_activity";

export type NotifyInput = {
  userIds: string[];
  type: NotifyType;
  title: string;
  body?: string;
  data?: Record<string, unknown>;
  organizationId?: string | null;
};

/**
 * Fire-and-forget notification. Writes an in-app row for each user_id and,
 * when FCM_SERVICE_ACCOUNT_JSON is configured on the backend, dispatches
 * the same event via Firebase Cloud Messaging to their device tokens.
 * Never throws — notification failures should not block the caller.
 */
export async function notify(input: NotifyInput): Promise<void> {
  const cleanUserIds = Array.from(new Set(input.userIds.filter(Boolean)));
  if (cleanUserIds.length === 0) return;
  try {
    await supabase.functions.invoke("notify", {
      body: {
        user_ids: cleanUserIds,
        type: input.type,
        title: input.title,
        body: input.body,
        data: input.data ?? {},
        organization_id: input.organizationId ?? null,
      },
    });
  } catch (e) {
    // Intentional swallow — surfaced via console for observability.
    // Callers proceed regardless of notification delivery.
    console.warn("notify failed", e);
  }
}
